// AI-CONTEXT: See docs/features/livereport-per-deelnemer.md (T2) en
// docs/test-runs/2026-10-20-rapportage-per-deelnemer.md (B3)
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import describeReportPersona from '../../../../helpers/liveReportHelpers/describeReportPersona';

/**
 * De knop 'Deelnemer kiezen' met de deelnemer van het rapport erop. Nodig
 * omdat de rapportagetabel en de kopregel van het rapport dezelfde knop tonen;
 * het venster (ReportPersonaSelector) beheert de aanroeper, want in de tabel
 * moet het buiten de klikbare rij staan.
 *
 * @param {object} props
 * @param {import('../../../../types/LiveReports2').LiveReports2Doc} props.report - Het rapport
 * @param {Array<{ID: string, Name?: string}> | undefined | null} props.personas - Deelnemers; `undefined`/`null` = nog niet geladen
 * @param {(e: React.MouseEvent) => void} props.onClick - Opent de kiezer
 * @returns {JSX.Element}
 */
const ReportPersonaButton = ({ report, personas, onClick }) => {
    const persona = describeReportPersona(report, personas);
    return (
        <button
            type="button"
            className={`reports-period-button reports-persona-button--${persona.state}`}
            title="Deelnemer kiezen"
            aria-label="Deelnemer kiezen"
            onClick={onClick}
        >
            <PersonOutlineOutlinedIcon />
            <span>{persona.label}</span>
        </button>
    );
};

export default ReportPersonaButton;
